import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSessionStore, isTokenExpired } from '../stores/sessionStore';

export function ProtectedRoute() {
  const location = useLocation();
  const hydrated = useSessionStore((state) => state.hydrated);
  const session = useSessionStore((state) => state.session);
  const clear = useSessionStore((state) => state.clear);

  const token = session?.access_token;
  const expired = isTokenExpired(token);

  useEffect(() => {
    if (token && expired) {
      console.warn('[ProtectedRoute] Token expirado detectado na rota protegida. Limpando sessão.');
      clear();
    }
  }, [token, expired, clear]);

  if (!hydrated) {
    return <div className="screen-state">Carregando sessão...</div>;
  }

  if (!token || expired) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
